import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import animateScrollTo from 'animated-scroll-to';
import { DFPManager } from 'react-dfp';
import { withRouter } from 'react-router-dom';
import { optionalCookiesAllowed } from '../../../helpers/optionalCookies';
import {
    newsArticleSchema, newsDescription, newsText,
} from '../helpers/newsSeo';
import A1GA from '../../../helpers/A1GA';
/* import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons'; */
import Button from '../../../common/button/Button';
import NewsMostRead from './NewsMostReadComponent';
import HeaderTags from '../../../common/headerTags/HeaderTags';
import Placeholder from '../../../common/placeholder/Placeholder';
import NewsSlider from './NewsSlider';
// import Banner from '../../../common/Banner/Banner';
import Sharing from '../../../common/sharing/Sharing';
// import FacebookComments from '../../../common/comments/Comments';
import ErrorPage from '../../../common/errorPage/ErrorPage';
import { transformHTML } from '../../../helpers/transformHTML';
import PlaceholderImage from '../../../common/placeholderImage/PlaceholderImage';
import { trackNewsHit } from '../../../helpers/Tracking';
// import VoteIcon from "../containers/VoteIconContainer";
import VideoPlayer from '../../../common/VideoPlayer/VideoPlayerComponent';
// import InteractiveContainer from '../../../common/interactiveContainer/InteractiveContainer';
// import NewsBlock from '../containers/NewsBlockContainer';
import JournalistOnNews from '../../journalists/components/journalistOnNewsComponent';
import EmbededPodcast from '../../../common/EmbededPodcast/EmbededPodcast';
// import ProBadge from '../../../common/ProBadge/ProBadge';
import Youtube from '../../../common/Youtube/Youtube';
import formatDateToBR from '../../../utils/formatDateToBR';
import NewsAoVivoMostReadContainer from '../../aovivo/containers/NewsAoVivoMostReadContainer';
import SuperSimSponsoredArticleNotice from '../../../common/editorialAd/SuperSimSponsoredArticleNotice';
import {
    isSuperSimSponsoredNews as isSuperSimSponsoredNewsItem,
    SUPERSIM_SPONSORED_NEWS_IMAGE_ALT,
    SUPERSIM_SPONSORED_NEWS_IMAGE_PATH,
} from '../helpers/superSimSponsoredNews';

// facebook open graph
const A1MEDIA_FACEBOOK = 'https://a1media.antena1.com.br/image/news/1200x630/';
// images paths
const A1MEDIA_LARGE = 'https://a1media.antena1.com.br/image/news/1024x536/';
const A1MEDIA_SMALL = 'https://a1media.antena1.com.br/image/news/752x392/';
const A1MEDIA_EXTRA_SMALL = 'https://a1media.antena1.com.br/image/news/560x292/';
// Banners
// const firstRectangleBannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'banner',
//     adUnit: 'a1nova-singleNews-first_rectangle-300x250',
//     sizes: [[300, 250]],
//     shouldRefresh: true,
// };
// const firstLeaderboardBannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'col-12',
//     adUnit: 'a1nova-singleNews-first_leaderboard-multi_sizes',
//     sizes: [[468, 60], [320, 50], [234, 60]],
//     sizeMapping: [
//         { viewport: [550, 0], sizes: [[468, 60], [320, 50], [234, 60]] },
//         { viewport: [0, 0], sizes: [[320, 50], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };
// const secondLeaderboardBannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'col-12',
//     adUnit: 'a1nova-singleNews-second_leaderboard-multi_sizes',
//     sizes: [[468, 60], [320, 50], [234, 60]],
//     sizeMapping: [
//         { viewport: [550, 0], sizes: [[468, 60], [320, 50], [234, 60]] },
//         { viewport: [0, 0], sizes: [[320, 50], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };
// const multiBannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'col-12',
//     adUnit: 'a1nova-singleNews-multi_multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };


export class TagsNews extends Component {
    _mapTags() {
        return this.props.dataTagsNews.map((data) => (
            <li key={data.slug}>
                <Button title={`Tag ${data.nome}`} to={`/noticias/tags/${data.slug}`}>
                    {data.nome}
                </Button>
            </li>
        ));
    }

    render() {
        return (
            <div className="tags">
                <p className="tagsTitle">Tags</p>
                {
                    !this.props.isFetching ?
                        <ul>
                            {(this.props.dataTagsNews && this.props.dataTagsNews.length > 0) ? this._mapTags() : ''}
                        </ul> :
                        <Placeholder minHeight="150px" />
                }
            </div>
        );
    }
}

TagsNews.propTypes = exact({
    dataTagsNews: PropTypes.array,
    isFetching: PropTypes.bool,
});

class NewsSingle extends Component {
    constructor(props) {
        super(props);

        this.state = {
            blockClass: 'block-right',
            stopBlock: false,
            distancieRightFixedMenu: 0,
            distancieTopFixedMenu: 0,
            additionalNewsFetched: 'not initiated',
            hasMounted: false,
        };

        this.newsContentMain;

        this._updateFixedMenuDistances = this._updateFixedMenuDistances.bind(this);

        this._listenerResize = this._listenerResize.bind(this);

        this._listenerScroll = this._listenerScroll.bind(this);

        this._setLayoutProps = this._setLayoutProps.bind(this);

        this._handleUserWantsToBePro = this._handleUserWantsToBePro.bind(this);
    }

    componentDidMount() {
        this.setState({ hasMounted: true });

        // fetch data news sending slug (when navigation client side)
        // Note: no need to check for PRO content here as the user object was not yet
        // fetched so we don't know if the user is PRO or not. This will be handled in didUpdate...
        this.props.fetchDataSingleNewsIfNeeded(this.props.slug);

        // fetch data to news most read if is not in mobile and tablet
        const breakpoint = this.props.breakpoint;

        if (!breakpoint.isSmall &&
            !breakpoint.isExtraSmall &&
            !breakpoint.isMedium) {
            this.props.fetchDataNewsMostReadIfNeeded();
        }

        this._setLayoutProps();

        this._updateFixedMenuDistances();

        // bind event scroll
        if (window.addEventListener) { // For all major browsers, except IE 8 and earlier
            window.addEventListener('scroll', this._listenerScroll);

            window.addEventListener('resize', this._listenerResize);
        } else if (window.attachEvent) { // For IE 8 and earlier versions
            window.attachEvent('scroll', this._listenerScroll);

            window.attachEvent('resize', this._listenerResize);
        }

        // go to top
        animateScrollTo(0, { speed: 700 });

        // set the additionalNews flag after scrolling to top
        window.setTimeout(() => this.setState({ additionalNewsFetched: false }), 2000);

        // log the view to google analytics (this is mostly a test to figure out he difference between the lida count and the analytics page views)
        // @TODO remove this, once the discrepancy between the lida count and the pageviews was resolved and if this does not add extra value to our analytics
        A1GA.event({
            category: 'News',
            action: 'news_opened',
            label: this.props.slug,
            nonInteraction: true, // test if this will change back the bounce rate drop on the news pageviews (2018-07-06) (I assume that it dropped because this event was seen as user initiated, and thus falsificated the bounce rate)
        });

        // log the view to our database
        trackNewsHit(this.props.slug);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.slug !== this.props.slug) {
            // new news was opened
            // refresh  DFP Banners of page
            if (optionalCookiesAllowed()) DFPManager.refresh();

            // fetch the "normal content" as we do not yet know if the news is PRO or not
            // the PRO part will be fetched in a next step, if necessary
            this.props.fetchDataSingleNewsIfNeeded(this.props.slug);

            this._setLayoutProps();

            // fetch data to news most read if is not in mobile and tablet
            const breakpoint = this.props.breakpoint;

            if (!breakpoint.isSmall &&
                !breakpoint.isExtraSmall &&
                !breakpoint.isMedium) {
                this.props.fetchDataNewsMostReadIfNeeded();
            }

            // go to top
            animateScrollTo(0, { speed: 700 });

            // reset the additionalNews flag after scrolling to top
            window.setTimeout(() => this.setState({ additionalNewsFetched: false }), 2000);

            // log the view to google analytics (this is mostly a test to figure out he difference between the lida count and the analytics page views)
            // @TODO remove this, once the discrepancy between the lida count and the pageviews was resolved and if this does not add extra value to our analytics
            A1GA.event({
                category: 'News',
                action: 'news_opened',
                label: this.props.slug,
                nonInteraction: true, // test if this will change back the bounce rate drop on the news pageviews (2018-07-06) (I assume that it dropped because this event was seen as user initiated, and thus falsificated the bounce rate)
            });

            // log the view to our database
            trackNewsHit(this.props.slug);
        }

        if (prevProps.dataSingleNews !== this.props.dataSingleNews && !this.props.dataSingleNews.fullContent) {
            // (new) news data fetched but the PRO part misses. Fetch it, if the user is PRO
            if (this.props.userIsPro) {
                // (not fetching additional news here, as they have already been fetched before)
                this.props.fetchDataSingleProNews(this.props.slug);
            }
        }

        if (prevProps.userIsPro !== this.props.userIsPro && this.props.userIsPro) {
            // the user object was now fetched or the user just became PRO
            // fetch the PRO content, if the news is PRO
            if (this.props.dataSingleNews.pro) {
                // (not fetching additional news here, as they have already been fetched before)
                this.props.fetchDataSingleProNews(this.props.slug);
            }
        }
    }

    componentWillUnmount() {
        this.props.setNotFound(false); // clear the notFound flag

        // clear event listener when componet is unMount
        if (window.removeEventListener) {
            // For all major browsers, except IE 8 and earlier
            window.removeEventListener('scroll', this._listenerScroll);

            window.removeEventListener('resize', this._listenerResize);
        } else if (window.detachEvent) {
            // For IE 8 and earlier versions
            window.detachEvent('scroll', this._listenerScrol);

            window.detachEvent('resize', this._listenerResize);
        }
    }


    _updateFixedMenuDistances() {
        const rightBlock = document.getElementById('right-block');
        const headerBar = document.getElementsByClassName('headerBar')[0];

        if (rightBlock && headerBar) {
            const right = window.innerWidth - rightBlock.getBoundingClientRect().right;
            const top = headerBar.getBoundingClientRect().bottom + 20;


            this.setState({
                distancieRightFixedMenu: right,
                distancieTopFixedMenu: top,
            });
        }
    }

    _listenerResize() {
        this._setLayoutProps();

        this._updateFixedMenuDistances();
    }

    _setLayoutProps() {
        if (this.newsContentMain && document.getElementById('container-menu')) {
            // get distancie base to set in rigth to fixed Menu
            const distancieRightFixedMenu = this.newsContentMain.offsetLeft;

            this.setState({
                distancieRightFixedMenu,
                distancieTopFixedMenu: 80, // hardcoded until this mess was fixed. Also for PRO users without ads...
            });
        }

        // const rightBlock = document.getElementById('right-block');

        // if (rightBlock) {
        // const width = rightBlock.offsetWidth;

        // this.setState({ rightBlockWidth: width });
        // }
    }

    _listenerScroll() {
        // Check if we need to fetch additional news (related and latest)

        if (!this.state.additionalNewsFetched && this.props.dataSingleNews.tagNews) {
            // Note: The check for tagNews is necessary in the case when
            const windowBottom = window.scrollY + window.innerHeight;
            const contentMainHeight = document.getElementsByClassName('news-contentMain')[0].getBoundingClientRect().height;
            const minDistance = 500;

            if (contentMainHeight - windowBottom <= minDistance) {
                // We are close to the end of the content, load the additional news

                this.props.fetchDataRelatedNewsIfNeeded(this.props.dataSingleNews.tagNews, 5);

                this.setState({ additionalNewsFetched: true });
            }
        }

        // Most related news dont show on small displays
        const showMostRead = !(this.props.breakpoint.isMedium || this.props.breakpoint.isSmall || this.props.breakpoint.isExtraSmall);

        if (showMostRead) {
            const mostReadRect = document.getElementById('right-block').getBoundingClientRect();
            const headerBarRect = document.getElementsByClassName('headerBar')[0].getBoundingClientRect();
            const contentMainRect = document.getElementsByClassName('news-contentMain')[0].getBoundingClientRect();

            // Distances between elements
            const topDist = headerBarRect.bottom - mostReadRect.top - 1; // this is layout sensitive. the "- 1" is a adjust for unknown layout micro diffs
            const imageDist = contentMainRect.top - mostReadRect.top;
            const bottomDist = mostReadRect.bottom - contentMainRect.bottom;
            const newBlockClass = this.state.blockClass;
            const newStopBlock = this.state.stopBlock;
            const stopElementRect = document.getElementById('newsRelated')?.getBoundingClientRect();

            // Check the distance between the blue bar and the top of mostRead to allow the container scroll
            if ((topDist > 0 && !this.state.stopBlock) || (topDist < 0 && this.state.stopBlock)) {
                this.setState({
                    blockClass: 'block-fixed',
                    stopBlock: false,
                });
            } else if (imageDist > 0) { // Check if mostRead already arrived on top of contentMain container and stop it
                this.setState({
                    blockClass: 'block-fixed',
                    stopBlock: false,
                });
            } else if (bottomDist > 0 && this.state.blockClass === 'block-fixed') { // Check if mostRead already arrived at bottom
                this.setState({ // of contentMain container and stop it
                    blockClass: 'onBottom',
                    stopBlock: true,
                });
            }

            if (newBlockClass !== this.state.blockClass || newStopBlock !== this.state.stopBlock) {
                this.setState({
                    blockClass: newBlockClass,
                    stopBlock: newStopBlock,
                });
            }

            if (stopElementRect && mostReadRect.bottom >= stopElementRect.top) {
                this.setState({
                    blockClass: 'onBottom',
                    stopBlock: true,
                });
            }
        }
    }

    // Method redirects to become a PRO and register on GA
    _handleUserWantsToBePro() {
        A1GA.event({
            category: 'News',
            action: 'user_wants_to_be_pro',
            label: this.props.slug,
            nonInteraction: false,
        });

        this.props.history.push('/vantagens-da-assinatura-pro');
    }


    render() {
        if (this.props.notFound) {
            return <ErrorPage
                errorNumber={404}
                backLink="/noticias"
                title="NÃO ACHAMOS ESSA NOTÍCIA :("
                message="Verifique se o link foi digitado corretamente."
                buttonText="Clique aqui para ler outras notícias"
            />;
        }

        const dataRelatedNews = this.props.dataRelatedNews.filter((item) => item.slug !== this.props.slug);
        const breakpoint = this.props.breakpoint;
        const responsiveBreakpoints = this.state.hasMounted ? breakpoint : breakpoint.serverBreakPoints;
        const isResponsive = (name) => responsiveBreakpoints && responsiveBreakpoints[name];
        // const dataSingleNews = this.props.dataSingleNews ? this.props.dataSingleNews : '';
        const dataSingleNews = this.props.dataSingleNews.newsId ? this.props.dataSingleNews : '';
        // work in date
        // const newsDate = `${new Date(dataSingleNews.date).toLocaleDateString()} ${new Date(dataSingleNews.date).toLocaleTimeString()}`;
        // Image URL — use srcset so server and client render identical HTML (no hydration mismatch)
        let coverImageSrc = '';
        let coverImageSrcSet;
        let coverImageSizes;
        const isSuperSimSponsoredNews = isSuperSimSponsoredNewsItem(dataSingleNews);
        const sponsoredArticleImageSrc = isSuperSimSponsoredNews ? SUPERSIM_SPONSORED_NEWS_IMAGE_PATH : null;

        if (dataSingleNews.imageUrl) {
            coverImageSrc = dataSingleNews.imageUrl;
        } else if (dataSingleNews.imageNew) {
            const encoded = encodeURI(dataSingleNews.imageNew);

            coverImageSrc = `${A1MEDIA_LARGE}${encoded}`;
            coverImageSrcSet = `${A1MEDIA_EXTRA_SMALL}${encoded} 560w, ${A1MEDIA_SMALL}${encoded} 752w, ${A1MEDIA_LARGE}${encoded} 1024w`;
            coverImageSizes = '(max-width: 575px) 560px, (max-width: 767px) 752px, 1024px';
        } else if (sponsoredArticleImageSrc) {
            coverImageSrc = sponsoredArticleImageSrc;
        } else {
            coverImageSrc = `https://a1media.antena1.com.br/image/news/${dataSingleNews.imageLink}`;
        }

        const imageMinHeigthToLoader = dataSingleNews.imageUrl || sponsoredArticleImageSrc ? '400px' : '536px';
        const imageWidthToShare = 1200;
        const imageHeightToShare = 630;
        const newsImageForMeta = dataSingleNews.imageUrl ||
            sponsoredArticleImageSrc ||
            (dataSingleNews.imageNew ? `${A1MEDIA_FACEBOOK}${encodeURI(dataSingleNews.imageNew)}` : '');

        // style to fixed menu
        const styleMenu = {
            position: this.state.blockClass === 'block-fixed' ? 'sticky' : 'static',
            right: this.state.blockClass === 'block-fixed' ? `${this.state.distancieRightFixedMenu}px` : undefined,
            top: this.state.blockClass === 'block-fixed' ? `${this.state.distancieTopFixedMenu}px` : undefined,
            bottom: this.state.blockClass === 'block-right' && this.state.stopBlock ? 0 : undefined,
            // width: this.state.blockClass === 'block-fixed' ? `${this.state.rightBlockWidth}px` : '',
            backgroundColor: this.state.blockClass === 'block-fixed' ? '#fff' : 'transparent',
            zIndex: 1000,
        };
        const jsonld = newsArticleSchema(dataSingleNews, this.props.slug, newsImageForMeta);

        // Tags meta and script
        const headerTags = {
            title: newsText(dataSingleNews.title),
            meta:
            {
                description: newsDescription(dataSingleNews),
                keywords: `informação, notícia${dataSingleNews.keyword !== null ? `, ${dataSingleNews.keyword}` : ''}`,
                'og:title': dataSingleNews.title,
                'og:description': newsDescription(dataSingleNews),
                'og:image': newsImageForMeta,
                'og:image:width': imageWidthToShare,
                'og:image:height': imageHeightToShare,
            },
            script:
                [
                    {
                        type: 'application/ld+json',
                        innerHTML: JSON.stringify(jsonld).replace(/</g, '\\u003c'),
                    },
                ],
        };
        const titleToShare = `Ouvi falar na Antena1.com.br: ${dataSingleNews.title} - `;
        const shareLocation = `/noticias/${this.props.slug ? this.props.slug : ''}`;
        const updateDate = dataSingleNews.updateDate && (dataSingleNews.updateDate !== dataSingleNews.date) && `${new Date(dataSingleNews.updateDate).toLocaleDateString()} ${new Date(dataSingleNews.updateDate).toLocaleTimeString()}`;
        const coverVideoFileName = dataSingleNews.coverVideoFileName;
        const coverVideoYoutubeId = dataSingleNews.coverVideoYoutubeId;
        // const pro = dataSingleNews.pro;
        let videoQuality = '480p';

        (breakpoint.isExtraLarge || breakpoint.isLarge || breakpoint.isMedium) && (videoQuality = '720p');

        let showNews = false;

        // validation to show news or loader
        if (!this.props.isFetching && this.props.slug === dataSingleNews.slug) {
            showNews = true;
        }

        return (
            <div className="">
                <div className="tw-container tw-m-auto tw-px-5">
                    <div className="newsSinglePageContainer">
                        <HeaderTags title={headerTags.title} meta={headerTags.meta} script={headerTags.script} />
                        <article className="newsSingle" id="newsSingle">
                            {/* <Button className="backToPage" title="Veja mais notícias." to="/noticias">
                          <img src="/keyboard-right-arrow-button.svg" alt="Ícone seta para a esquerda" />
                          {' '}
                          Veja todas as Notícias.
                      </Button> */}
                            <div className="newsBlockSingle">
                                <header>
                                    <h1 alt="Título da noticia">
                                        {dataSingleNews.title}
                                    </h1>
                                    <div className="tw-block md:tw-flex md:tw-justify-between md:tw-items-center">
                                        <p className="subTitleNews" alt="Descriçåo da notícia">
                                            {dataSingleNews.subtitle}
                                        </p>
                                        <div>
                                            <p className="newsAuthor" alt="Responsavél por escrever a matéria">
                                                {dataSingleNews.author}
                                            </p>
                                            <p className="newsDate" alt="Data de publicação da matéria">
                                                {formatDateToBR(dataSingleNews.date)}
                                            </p>
                                        </div>

                                    </div>
                                </header>
                                {/* pro && <ProBadge className="singleContentProBadge" title="Conteúdo PRO" /> */}
                                <div className="block-imageNews">
                                    {
                                        (coverVideoFileName || coverVideoYoutubeId) ? (
                                            coverVideoYoutubeId ?
                                                <div className="youtubeContainer">
                                                    <Youtube
                                                        videoId={coverVideoYoutubeId}
                                                    />
                                                </div>
                                                : coverVideoFileName &&
                                                <VideoPlayer
                                                    where="newsSingle"
                                                    videoQuality={videoQuality}
                                                    fileName={coverVideoFileName}
                                                />
                                        ) : showNews ?
                                            <figure>
                                                <PlaceholderImage
                                                    src={coverImageSrc}
                                                    srcSet={coverImageSrcSet}
                                                    sizes={coverImageSizes}
                                                    alt={
                                                        dataSingleNews.imageCaption ||
                                                        (isSuperSimSponsoredNews ? SUPERSIM_SPONSORED_NEWS_IMAGE_ALT : `Imagem da noticia "${dataSingleNews.title}"`)
                                                    }
                                                    placeholderHeight={imageMinHeigthToLoader}
                                                    playIconSize={dataSingleNews.coverVideo && 10}
                                                    playIconOnClick={this._handleUserWantsToBePro}
                                                    location={this.props.location}
                                                />
                                                {
                                                    dataSingleNews.imageCaption && (
                                                        <figcaption>
                                                            {dataSingleNews.imageCaption}
                                                        </figcaption>
                                                    )
                                                }
                                            </figure>
                                            :
                                            <Placeholder minHeight={imageMinHeigthToLoader} />
                                    }
                                </div>
                                <div ref={(newsContentMain) => { this.newsContentMain = newsContentMain; }} className="news-contentMain">
                                    <div className="block-center">
                                        {showNews && isSuperSimSponsoredNews && (
                                            <SuperSimSponsoredArticleNotice />
                                        )}

                                        {/* <InteractiveContainer /> */}

                                        {/* <VoteIcon
                                  like={dataSingleNews.like}
                                  dislike={dataSingleNews.dislike}
                                  idNews={dataSingleNews.newsId}
                              /> */}

                                        {
                                            showNews ?
                                                <div className="newsContent">
                                                    <div className="dateContainer">
                                                        {/* <div className="qtdRead">
                                              <FontAwesomeIcon icon={faEye} width="16" />
                                              <p>{dataSingleNews.reads + dataSingleNews.views}</p>
                                          </div> */}
                                                        <div>

                                                            {
                                                                updateDate &&
                                                                <p className="newsDate">
                                                                    Atualizada em &ensp;
                                                                    {formatDateToBR(updateDate)}
                                                                </p>
                                                            }
                                                        </div>
                                                    </div>
                                                    {
                                                        dataSingleNews.podcastId &&
                                                        <EmbededPodcast
                                                            key={`podcast-${dataSingleNews.podcastId}`}
                                                            podcastId={dataSingleNews.podcastId}
                                                            podcastType={dataSingleNews.podcastType}
                                                            playerStyle={dataSingleNews.podcastPlayerStyle}
                                                            playerType="standard"
                                                        />
                                                    }
                                                    <div className="content">
                                                        {
                                                            transformHTML(dataSingleNews.content, `Imagem de conteúdo da notícia "${dataSingleNews.title}"`)
                                                        }
                                                        {/*
                                                            !dataSingleNews.fullContent && <div className="shadowProContent" />
                                                        */}
                                                    </div>
                                                    {/*
                                                        !dataSingleNews.fullContent && (
                                                            <div className="becomeProContent">
                                                                Conteúdo somente para usuários PRO do Antena 1.
                                                                <Button className="becomeProButton" title="Quero ser PRO" onClick={this._handleUserWantsToBePro}>
                                                                    Quero ser PRO.
                                                                </Button>
                                                            </div>
                                                        )
                                                    */}
                                                </div>
                                                : <Placeholder minHeight="500px" />
                                        }

                                        <JournalistOnNews
                                            authorName={dataSingleNews.author}
                                            journalistName={dataSingleNews.journalistName}
                                            journalistSlug={dataSingleNews.journalistSlug}
                                            journalistImageFile={dataSingleNews.journalistImageFile}
                                        />

                                        <div className="shareBlock">
                                            <p>Compartilhar matéria</p>
                                            <Sharing
                                                styleEffect="pulseIcon"
                                                path={shareLocation}
                                                shareButtonsTo={['facebook', 'twitter', 'whatsapp', 'linkedin']}
                                                iconSize={28}
                                                widthBlockIcon={40}
                                                whatsapp={{ title: titleToShare }}
                                                facebook={{ quote: titleToShare, hashtag: '#Antena1' }}
                                                twitter={{ title: titleToShare, hashtags: ['Noticias', 'Antena1'] }}
                                                linkedin={{ title: titleToShare }}
                                            />
                                        </div>
                                        {dataSingleNews.tagNews && dataSingleNews.tagNews.length > 0 ?
                                            <TagsNews
                                                dataTagsNews={dataSingleNews.tagNews}
                                                isFetching={this.props.isFetching}
                                            /> : ''}


                                        {/* <Banner key={firstLeaderboardBannerConfig.adUnit} config={firstLeaderboardBannerConfig} /> */}

                                        {/* <FacebookComments location={shareLocation} /> */}

                                        {/* <Banner key={secondLeaderboardBannerConfig.adUnit} config={secondLeaderboardBannerConfig} /> */}

                                    </div>
                                </div>
                            </div>
                            <div className="wrapper-right-block">
                                {
                                    (isResponsive('isSmall') === false && isResponsive('isExtraSmall') === false && isResponsive('isMedium') === false) ?
                                        <div className={this.state.blockClass} style={styleMenu} id="right-block">
                                            {/* <Banner key={firstRectangleBannerConfig.adUnit} config={firstRectangleBannerConfig} /> */}
                                            <NewsMostRead
                                                dataNews={this.props.dataNewsMostRead || []}
                                                title="Mais lidas da semana"
                                                isFetching={this.props.isFetching}
                                            />
                                        </div>
                                        :
                                        ''
                                }
                            </div>
                        </article>
                        {dataRelatedNews.length >= 3 &&
                            // Only show the slider if there are at least 3 related news
                            <NewsSlider
                                news={dataRelatedNews}
                                title="Conteúdos relacionados"
                            />}

                    </div>

                </div>
                {this.state.additionalNewsFetched &&
                    // Only show the newsblock once the additionalNewsFetched flag is true.
                    // This (hopefully) avoids indexing of the newsblocks with the content of the single news (especially header videos...)
                    // <NewsBlock title="Últimas Notícias" category="tudo" isSinglePage singleId={dataSingleNews.newsId} />
                    <NewsAoVivoMostReadContainer />}
            </div>
        );
    }
}

NewsSingle.propTypes = exact({
    isFetching: PropTypes.bool,
    slug: PropTypes.string,

    fetchDataSingleNewsIfNeeded: PropTypes.func.isRequired,
    fetchDataSingleProNews: PropTypes.func.isRequired,
    dataSingleNews: PropTypes.object,
    fetchDataNewsMostReadIfNeeded: PropTypes.func,
    fetchDataRelatedNewsIfNeeded: PropTypes.func,
    dataNewsMostRead: PropTypes.array,
    breakpoint: PropTypes.object,
    dataRelatedNews: PropTypes.array,
    setNotFound: PropTypes.func,
    notFound: PropTypes.bool,
    userIsPro: PropTypes.bool.isRequired,
    history: PropTypes.object,
    /* eslint-disable react/no-unused-prop-types */
    staticContext: PropTypes.object, // Injected through withRouters but not used
    location: PropTypes.object, // Injected through withRouters but not used
    match: PropTypes.object, // Injected through withRouters but not used
    /* eslint-enable react/no-unused-prop-types */
});


export default withRouter(NewsSingle);
